GLOBAL.KeyCode = {
    Backspace: 8,
    Tab: 9,
    Enter: 13,
    Shift: 16,
    Ctrl: 17,
    Alt: 18,
    Escape: 27,
    Up: 38,
    Down: 40,
    Insert: 45
};
